import React from "react";
import styles from "./experience-card.module.scss";

interface ExperienceCardProps {
  company: string;
  location: string;
  role: string;
  period: string;
  description: string[];
}

const ExperienceCard: React.FC<ExperienceCardProps> = ({
  company,
  location,
  role,
  period,
  description,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.companyInfo}>
          <h3 className={styles.company}>
            {company}, {location}
          </h3>
          <p className={styles.role}>{role}</p>
        </div>
        <p className={styles.period}>{period}</p>
      </div>
      <ul className={styles.description}>
        {description.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default ExperienceCard;
